/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {Device} from '@ion/core/src/types/entities';
import {
  DevicePermissions,
  DevicesActionState,
  DevicesViewActionState
} from '../../pages/devices/state';
import {createDeepEqualSelector} from './SelectorUtils';

export const selectDevices           = ({devices}: any) => devices;
export const selectDeviceDetail      = state => selectDevices(state)?.deviceDetail;
export const selectDeviceSCI         = state => selectDevices(state)?.updateSCI;
export const selectDevicePermissions = state => selectDevices(state)?.devicePermissions;
export const selectDevicesEdit       = state => selectDevices(state)?.edit;
export const selectDevicesView       = state => selectDevices(state)?.view;

export const deviceDetailSelector =
createDeepEqualSelector([selectDeviceDetail], (deviceDetail: Device) => deviceDetail);

export const deviceSCISelector =
createDeepEqualSelector([selectDeviceSCI], (updateSCI: DevicesActionState) => updateSCI);

export const devicePermissionsSelector =
createDeepEqualSelector([selectDevicePermissions], (devicePermissions: DevicePermissions) => devicePermissions);

export const devicesEditSelector =
  createDeepEqualSelector([selectDevicesEdit], (edit: DevicesActionState) => edit);

export const devicesViewSelector =
  createDeepEqualSelector([selectDevicesView], (view: DevicesViewActionState) => view);
